import { makeAutoObservable } from "mobx"
import Store from ".."
import LoyaltyStoreX from "../loyalty"
import { createFav, getFavs } from "../../api/users"
import { message } from "antd"

export default class ShopApiStore {

  mainStore: Store
  loyaltyStore: LoyaltyStoreX

  favorites: any[] = []

  constructor(main: Store, loyalty: LoyaltyStoreX) {
    makeAutoObservable(this)

    this.mainStore = main
    this.loyaltyStore = loyalty
  }

  setFavorites = (val: any) => this.favorites 

  public async fetchFavorites() {
    const res = await getFavs()
    this.setFavorites(res)
  }

  public async addToFavorite(id: number) {
    const res = await createFav({user_id: this.mainStore.userData.id, product_id: id})
  
    if (res.state === 1) {
      message.success("Товар добавлен в избранное!")
    } else {
      message.success("Товар удален из избранного!")
    }

    this.fetchFavorites()
  }

}